export enum ColumnType {
  text = 'text',
  number = 'number',
  date = 'date',
  button = 'button',
  link = 'link',
  list = 'list',
  status = 'status',
  state = 'state',
}

export enum SortOrder {
  asc = 1,
  desc = -1,
  none = 'none',
}
export enum ServiceStatus {
  pending = 'pending',
  inProgress = 'inProgress',
  onHold = 'onHold',
  completed = 'completed',
}

export enum ServiceProgressPriority {
  low = 'low',
  medium = 'medium',
  high = 'high'
}